import React, { useState } from 'react';
import { Dropdown, Menu, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import Messages from 'i18n/messages/home';
import RunQueryControl from '../../controls/advanced-search/RunQueryControl';

import { Can } from 'context/Can';
import { RibbonButton, RibbonSection } from 'common/components';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import { ADVANCED_FILTER_MODE } from 'pages/reporting/utils/constants';

const REPORT_EXPORT_TYPE_ADVANCED = ['XLS', 'XLSX', 'JSON', 'XML'];

const REPORT_EXPORT_TYPE_FLAT = ['XLS', 'XLSX', 'CSV', 'JSON', 'XML'];

const QuerySection = (props) => {
  const { disableRun, modeData, onClickRibbonBtn, disabledExportQuery } = props;
  const [loading, setLoading] = useState();

  const onClickRunBtn = () => {
    onClickRibbonBtn('run');
  };

  const onClickExportBtn = (exportType) => {
    setLoading(true);
    onClickRibbonBtn('export', { setLoading, exportType });
  };

  const exportType =
    modeData === ADVANCED_FILTER_MODE.NESTED_DATA
      ? REPORT_EXPORT_TYPE_ADVANCED
      : REPORT_EXPORT_TYPE_FLAT;

  const menu = (
    <Menu>
      {exportType.map((exportType) => {
        return (
          <Menu.Item
            onClick={() => {
              onClickExportBtn(exportType);
            }}
            key={exportType}
          >
            <Typography.Text
              strong
              style={{ cursor: 'pointer', padding: '0 16px 0 4px' }}
            >
              <DownloadOutlined style={{ marginRight: 4 }} /> {exportType}
            </Typography.Text>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <RibbonSection>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <RunQueryControl disabled={disableRun} onClick={onClickRunBtn} />
      </Can>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <Dropdown overlay={menu} overlayStyle={{ height: 200 }}>
          <RibbonButton
            loading={loading}
            icon={<DownloadOutlined />}
            label={Messages.exportQuery}
            disabled={disabledExportQuery}
          />
        </Dropdown>
      </Can>
    </RibbonSection>
  );
};

export default QuerySection;
